import { usePersonalizedLettersStore } from 'assets/js/pages/engage/letters/usePersonalizedLettersStore';
import { Contact } from 'types/domain';

const useSetPersonalizedContact = () => {
    const {
        setCurrentPersonalizedLetterContact,
        setIsUnsavedChangesDialogOpen,
        hasDiffFromMasterLetter,
        setNextPersonalizedLetterContact,
    } = usePersonalizedLettersStore();

    return (contact: Contact) => {
        if (hasDiffFromMasterLetter) {
            setNextPersonalizedLetterContact(contact);
            return setIsUnsavedChangesDialogOpen(true);
        }

        return setCurrentPersonalizedLetterContact(contact);
    };
};

export { useSetPersonalizedContact };
